import React, { useRef } from "react";
import Select from "react-select";
export interface IOption {
  label: string;
  value: string;
  [key: string]: any;
}

export const SelectWrapper: React.FC<{
  options: Array<IOption>;
  onChange: (value: any) => void;
  styles?: any;
  onInputChange?: (input: string) => void;
  value?: string | undefined;
  className?: string;
  controlClassName?: string;
  inputClassName?: string;
  isLoading?: boolean;
  placeholder?: string;
  name?: string;
  isDisabled?: boolean;
}> = (Props) => {
  const timer = useRef<ReturnType<typeof setTimeout>>();

  const customStyles = {
    control: (base) => ({
      ...base,
      paddingTop: "4px",
      paddingBottom: "4px",
      borderRadius: "5px",
    }),
  };

  return (
    <Select
      placeholder={Props.placeholder}
      name={Props.name}
      onChange={(selected) => {
        Props.onChange(selected);
      }}
      onInputChange={(input) => {
        if (timer.current) {
          clearTimeout(timer.current);
        }
        timer.current = setTimeout(() => {
          Props.onInputChange && Props.onInputChange(input);
        }, 500);
      }}
      className={`${Props.className} text-dark`}
      value={Props.options?.filter((option) => {
        return option.value === Props.value;
      })}
      options={Props.options}
      isClearable
      isLoading={Props.isLoading}
      styles={Props.styles ? Props.styles : customStyles}
      isDisabled={Props.isDisabled}
    />
  );
};
